import { render, staticRenderFns } from "./PartnerRegisterCopySearchPrev.vue?vue&type=template&id=7f05be50&"
import script from "./PartnerRegisterCopySearchPrev.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterCopySearchPrev.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports